<template>
  <div class="privacy-policy">
    <div class="container mx-auto px-4 py-8">
      <div class="max-w-4xl mx-auto">
        <h1 class="text-4xl font-bold text-white mb-8">Privacy Policy</h1>
        <div class="bg-gray-800 rounded-lg p-8 text-gray-300 space-y-6">
          
          <section>
            <h2 class="text-2xl font-semibold text-white mb-4">1. Information We Collect</h2>
            <div class="space-y-4">
              <div>
                <h3 class="text-lg font-medium text-blue-400 mb-2">Automatically Collected Information</h3>
                <ul class="list-disc list-inside space-y-2 ml-4">
                  <li>IP address and location data</li>
                  <li>Browser type and version</li>
                  <li>Device information</li>
                  <li>Pages visited and time spent on site</li>
                  <li>Referral sources</li>
                  <li>Game preferences and usage patterns</li>
                </ul>
              </div>
              <div>
                <h3 class="text-lg font-medium text-blue-400 mb-2">Information You Provide</h3>
                <ul class="list-disc list-inside space-y-2 ml-4">
                  <li>Account registration information</li>
                  <li>Profile information and preferences</li>
                  <li>Communications with our support team</li>
                  <li>Feedback and reviews</li>
                </ul>
              </div>
            </div>
          </section>

          <section>
            <h2 class="text-2xl font-semibold text-white mb-4">2. How We Use Your Information</h2>
            <ul class="list-disc list-inside space-y-2 ml-4">
              <li>Provide and improve our gaming platform services</li>
              <li>Personalize your gaming experience</li>
              <li>Analyze website usage and performance</li>
              <li>Display relevant advertisements through Google AdSense</li>
              <li>Communicate with you about updates and new features</li>
              <li>Ensure platform security and prevent fraud</li>
              <li>Comply with legal obligations</li>
            </ul>
          </section>

          <section>
            <h2 class="text-2xl font-semibold text-white mb-4">3. Google Services Integration</h2>
            <div class="space-y-4">
              <div>
                <h3 class="text-lg font-medium text-blue-400 mb-2">Google Analytics</h3>
                <p>We use Google Analytics to understand how users interact with our website. This service collects information such as how often users visit our site, what pages they visit, and what other sites they used prior to coming to our site.</p>
                <p class="mt-2">You can opt-out of Google Analytics by installing the <a href="https://tools.google.com/dlpage/gaoptout" class="text-blue-400 hover:text-blue-300 underline" target="_blank" rel="noopener">Google Analytics opt-out browser add-on</a>.</p>
              </div>
              <div>
                <h3 class="text-lg font-medium text-blue-400 mb-2">Google AdSense</h3>
                <p>We use Google AdSense to display advertisements. Google may use cookies and web beacons to serve ads based on your prior visits to our website or other websites. You can opt out of personalized advertising by visiting <a href="https://www.google.com/settings/ads" class="text-blue-400 hover:text-blue-300 underline" target="_blank" rel="noopener">Google's Ad Settings</a>.</p>
              </div>
            </div>
          </section>

          <section>
            <h2 class="text-2xl font-semibold text-white mb-4">4. Cookies and Tracking Technologies</h2>
            <div class="space-y-4">
              <p>We use cookies and similar tracking technologies to enhance your experience on our website:</p>
              <div>
                <h3 class="text-lg font-medium text-blue-400 mb-2">Essential Cookies</h3>
                <p>Required for basic website functionality and cannot be disabled.</p>
              </div>
              <div>
                <h3 class="text-lg font-medium text-blue-400 mb-2">Analytics Cookies</h3>
                <p>Help us understand how visitors use our website to improve user experience.</p>
              </div>
              <div>
                <h3 class="text-lg font-medium text-blue-400 mb-2">Advertising Cookies</h3>
                <p>Used to deliver relevant advertisements and measure ad campaign effectiveness.</p>
              </div>
            </div>
          </section>

          <section>
            <h2 class="text-2xl font-semibold text-white mb-4">5. Data Sharing and Third Parties</h2>
            <p>We do not sell, trade, or rent your personal information to third parties. We may share information with:</p>
            <ul class="list-disc list-inside space-y-2 ml-4 mt-4">
              <li>Service providers who assist in operating our website</li>
              <li>Analytics and advertising partners (Google Analytics, Google AdSense)</li>
              <li>Legal authorities when required by law</li>
              <li>Business partners in case of merger or acquisition</li>
            </ul>
          </section>

          <section>
            <h2 class="text-2xl font-semibold text-white mb-4">6. Data Security</h2>
            <p>We implement appropriate security measures to protect your personal information:</p>
            <ul class="list-disc list-inside space-y-2 ml-4 mt-4">
              <li>Encryption of data in transit and at rest</li>
              <li>Regular security audits and updates</li>
              <li>Access controls and authentication</li>
              <li>Secure hosting infrastructure</li>
            </ul>
          </section>

          <section>
            <h2 class="text-2xl font-semibold text-white mb-4">7. Your Rights and Choices</h2>
            <p>You have the following rights regarding your personal data:</p>
            <ul class="list-disc list-inside space-y-2 ml-4 mt-4">
              <li><strong>Access:</strong> Request copies of your personal data</li>
              <li><strong>Rectification:</strong> Request correction of inaccurate data</li>
              <li><strong>Erasure:</strong> Request deletion of your personal data</li>
              <li><strong>Portability:</strong> Request transfer of your data</li>
              <li><strong>Objection:</strong> Object to processing of your data</li>
              <li><strong>Restriction:</strong> Request restriction of data processing</li>
            </ul>
            <p class="mt-4">To exercise these rights, please contact us at <a href="mailto:zhangshuaidoc@163.com" class="text-blue-400 hover:text-blue-300 underline">zhangshuaidoc@163.com</a>.</p>
          </section>

          <section>
            <h2 class="text-2xl font-semibold text-white mb-4">8. Children's Privacy</h2>
            <p>Our service is not directed to children under 13 years of age. We do not knowingly collect personal information from children under 13. If you are a parent or guardian and believe your child has provided us with personal information, please contact us immediately.</p>
          </section>

          <section>
            <h2 class="text-2xl font-semibold text-white mb-4">9. International Data Transfers</h2>
            <p>Your information may be transferred to and processed in countries other than your own. We ensure appropriate safeguards are in place to protect your data in accordance with applicable privacy laws.</p>
          </section>

          <section>
            <h2 class="text-2xl font-semibold text-white mb-4">10. Changes to This Policy</h2>
            <p>We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last Updated" date below.</p>
          </section>

          <section>
            <h2 class="text-2xl font-semibold text-white mb-4">11. Contact Information</h2>
            <p>If you have any questions about this Privacy Policy, please contact us:</p>
            <div class="mt-4 p-4 bg-gray-700 rounded-lg">
              <p><strong>Email:</strong> <a href="mailto:zhangshuaidoc@163.com" class="text-blue-400 hover:text-blue-300 underline">zhangshuaidoc@163.com</a></p>
              <p><strong>Website:</strong> <a href="https://cybergamehub.com" class="text-blue-400 hover:text-blue-300 underline">https://cybergamehub.com</a></p>
              <p><strong>Business Hours:</strong> 9:00-18:00 (UTC+8)</p>
            </div>
          </section>

          <div class="mt-8 pt-6 border-t border-gray-700">
            <p class="text-sm text-gray-400">
              <strong>Last Updated:</strong> {{ new Date().toLocaleDateString() }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Privacy',
  mounted() {
    // Update page title
    document.title = 'Privacy Policy - CyberGame Hub'
    
    // Track page view
    if (window.gtag) {
      window.gtag('config', 'G-45VN2LK7EM', {
        page_title: 'Privacy Policy',
        page_location: window.location.href,
        page_path: '/privacy'
      })
    }
  }
}
</script>

<style scoped>
.privacy-policy {
  min-height: 100vh;
  padding-top: 2rem;
  padding-bottom: 2rem;
}

.privacy-policy h1 {
  background: linear-gradient(135deg, #60a5fa, #a78bfa);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.privacy-policy h2 {
  border-bottom: 2px solid #374151;
  padding-bottom: 0.5rem;
}

.privacy-policy a {
  transition: color 0.2s ease-in-out;
}

@media (max-width: 768px) {
  .privacy-policy {
    padding-top: 1rem;
  }
  
  .privacy-policy h1 {
    font-size: 2rem;
  }
  
  .privacy-policy .bg-gray-800 {
    padding: 1.5rem;
  }
}
</style>
